export type ThemeMode = 'light' | 'dark' | 'system'
export type ResolvedTheme = 'light' | 'dark'

export const THEME_STORAGE_KEY = 'gongkao-theme-mode'

export function isThemeMode(value: string | null): value is ThemeMode {
  return value === 'light' || value === 'dark' || value === 'system'
}

export function resolveTheme(mode: ThemeMode, prefersDark: boolean): ResolvedTheme {
  return mode === 'system' ? (prefersDark ? 'dark' : 'light') : mode
}

export function readStoredTheme(storage?: Pick<Storage, 'getItem'>): ThemeMode {
  if (!storage) return 'system'
  const stored = storage.getItem(THEME_STORAGE_KEY)
  return isThemeMode(stored) ? stored : 'system'
}

export function applyResolvedTheme(
  theme: ResolvedTheme,
  root?: Pick<HTMLElement, 'dataset' | 'style'>,
): void {
  if (!root) return
  root.dataset.theme = theme
  root.style.colorScheme = theme
}
